import {
  Button,
  HeadingText,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useTobaccoStore } from '../store/tobacco-use.form-store';
import TobaccoUsageLabel from '../tobacco-use-labels.json';
import Dependents from './tobacco-use.dependent.component';
import LoginUser from './tobacco-use.loginUser.component';
import { tobaccoUse } from '../tobacco-use.config';
import {
  isAboveEighteenAge,
  getAccessToken,
  postAccessToken,
} from '../helper/helpers';
import { AccountManagementContainer } from './pages/acctMgmtContainer.component';
import { NotificationModal } from './pages/notificationModal.component';

const config = tobaccoUse.getConfig();
const highmarkURL = config.HIGHMARK_API_URL;

function SubmitButton(props: { ubkValue: string }) {
  const { ubkValue } = props;

  const isDisabled = useTobaccoStore((state) => state.isDisabled);
  const setIsDisabled = useTobaccoStore((state) => state.setIsDisabled);
  const tobaccoUpdateUrl = useMemo(
    () => encodeURI(`${highmarkURL}/members/health/tobacco`),
    [],
  );

  const tobaccoApiResponse = useTobaccoStore(
    (state) => state.tobaccoApiResponse,
  );
  const loginUser = useTobaccoStore((state) => state.loginUser);

  const dependents = useTobaccoStore((state) => state.dependents);

  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);

  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);
  const initData = useTobaccoStore((state) => state.initData);
  // const demographicsApiRetryCount = useRef(0);
  const setTobaccoApiResponse = useTobaccoStore(
    (state) => state.setTobaccoApiResponse,
  );

  const submitRetryCount = useRef(0);

  const navigate = useNavigate();

  const tobaccoAPIUrl = useMemo(
    () => encodeURI(`${highmarkURL}/members/health/tobacco`),
    [],
  );

  const getTobaccoInfoData = (url: string) => {
    getAccessToken(url, ubkValue).then((result: any) => {
      if (!result?.errMsg) {
        setTobaccoApiResponse(result.payload.tobaccoInfo);
        initData();
      }
    });
  };

  const updateTobaccoInfoData = () => {
    const newusers = [...dependents];
    newusers.push(loginUser);

    tobaccoApiResponse?.tobaccoList.map((x) => {
      const result = newusers.filter(
        (a1) => a1.coveredIndividualId === x.member.coveredIndividualId,
      );
      // eslint-disable-next-line no-param-reassign
      if (result.length > 0) {
        // eslint-disable-next-line no-param-reassign
        x.tobaccoIndicator = result[0].tobaccoIndicator;
        // eslint-disable-next-line no-param-reassign
        x.tobaccoUseLastReportDate = result[0].tobaccoUseLastReportDate;
      }
      return x;
    });

    const updatedObject = {
      payload: {
        tobaccoInfo: tobaccoApiResponse,
      },
    };

    postAccessToken(tobaccoUpdateUrl, updatedObject, ubkValue).then(
      (result: any) => {
        if (!result.errMsg) {
          // setErrorModalIsOpen(true);
          setSuccessModalIsOpen(true);
          submitRetryCount.current = 0;
          getTobaccoInfoData(
            `${tobaccoAPIUrl}?clientId=${tobaccoApiResponse?.clientId}&groupId=${tobaccoApiResponse?.groupId}`,
          );

          // setMainFormModalIsOpen(false);
        } else {
          setErrorModalIsOpen(true);
        }
      },
    );
  };

  return (
    <>
      <Button
        hidden
        disabled={isDisabled}
        aria-disabled={isDisabled}
        css={{ minWidth: '135px' }}
        onClick={() => {
          setIsDisabled(true);
          updateTobaccoInfoData();
          // const success = true;
          // if (success) {
          //   setErrorModalIsOpen(true);
          // } else {
          //   setSuccessModalIsOpen(true);
          // }
        }}
      >
        Save Changes
      </Button>
      <NotificationModal
        modalOpen={errorModalIsOpen}
        onOpenChange={() => {
          if (submitRetryCount.current < 2) {
            setErrorModalIsOpen((previous: boolean) => !previous);
            setIsDisabled(false);
            submitRetryCount.current += 1;
          } else navigate('/home');
        }}
        type="Error"
      />
      <NotificationModal
        modalOpen={successModalIsOpen}
        onOpenChange={() => {
          setSuccessModalIsOpen((previous: boolean) => !previous);
        }}
        type="Success"
      />
    </>
  );
}

function FormContent(props: {
  isOffExchange: boolean;
  isOnExchange: boolean;
  ubkValue: string;
}) {
  const memberPlanUrl = useMemo(
    () => encodeURI(`${highmarkURL}/members/benefits/plans?planYear=all`),
    [],
  );

  const tobaccoAPIUrl = useMemo(
    () => encodeURI(`${highmarkURL}/members/health/tobacco`),
    [],
  );

  const demographyUrl = useMemo(
    () => encodeURI(`${highmarkURL}/members/demographics/profile`),
    [],
  );

  const { isOffExchange, isOnExchange, ubkValue } = props;

  const isBelowMinAgeLimit = useTobaccoStore(
    (state) => state.isBelowMinAgeLimit,
  );
  const setIsBelowMinAgeLimit = useTobaccoStore(
    (state) => state.setIsBelowMinAgeLimit,
  );
  const setOffExchangeVal = useTobaccoStore((state) => state.setOffExchangeVal);
  const setOnExchangeVal = useTobaccoStore((state) => state.setOnExchangeVal);

  const setTobaccoApiResponse = useTobaccoStore(
    (state) => state.setTobaccoApiResponse,
  );
  // TODO once we receive the tobacco retrieve API - configure it
  const initData = useTobaccoStore((state) => state.initData);
  // const demographicsApiRetryCount = useRef(0);

  const [prepopModalOpen, setPrepopModalOpen] = useState(false);

  const [nonACAModalOpen, setNonACAModalOpen] = useState(false);
  const isACA = true;
  const prepopRetryCount = useRef(0);
  const navigate = useNavigate();

  const getTobaccoInfoData = (url: string) => {
    getAccessToken(url, ubkValue)
      .then((result: any) => {
        if (!result?.errMsg) {
          setTobaccoApiResponse(result.payload.tobaccoInfo);
          initData();
        } else {
          setPrepopModalOpen(true);
        }
      })
      .catch(() => {
        setPrepopModalOpen(true);
      });
  };

  const getOnOffExchange = (plans: any) => {
    let planDetail;
    const currentYear =
      plans.length > 0 &&
      plans.filter(
        (plan: any) =>
          plan?.planType === 'medical' &&
          plan?.planYear === 'current' &&
          (plan?.hcrProduct === 'OFF' || plan?.hcrProduct === 'ON'),
      );

    if (currentYear.length === 0) {
      planDetail =
        plans.length > 0 &&
        plans.filter(
          (plan: any) =>
            plan?.planType === 'medical' &&
            plan?.planYear === 'past' &&
            (plan?.hcrProduct === 'OFF' || plan?.hcrProduct === 'ON'),
        );
    } else {
      planDetail = currentYear;
    }
    if (planDetail?.[0]?.hcrProduct) {
      if (planDetail?.[0]?.hcrProduct === 'OFF') {
        setOffExchangeVal(true);
      } else if (
        planDetail?.[0]?.hcrProduct === 'ON' ||
        planDetail?.[0]?.hcrProduct === '' ||
        planDetail?.[0]?.hcrProduct === null
      ) {
        setOnExchangeVal(true);
      }
    } else {
      setOnExchangeVal(true);
    }
  };

  const getClient = (plans: any) => {
    let planDetail;
    const currentYear =
      plans.length > 0 &&
      plans.filter(
        (plan: any) =>
          plan.planType === 'medical' &&
          plan.planYear === 'current' &&
          (plan?.hcrProduct === 'OFF' || plan?.hcrProduct === 'ON'),
      );
    if (currentYear.length === 0) {
      planDetail =
        plans.length > 0 &&
        plans.filter(
          (plan: any) =>
            plan.planType === 'medical' &&
            plan.planYear === 'past' &&
            (plan?.hcrProduct === 'OFF' || plan?.hcrProduct === 'ON'),
        );
    } else {
      planDetail = currentYear;
    }

    return planDetail[0];
  };

  useEffect(() => {
    // no need to call plan and tobacco api for below eighteen user
    // only retrieve data if the tobacco use store does not already have it
    /* when modalOpen is changed due to the API failing it will try to
    run the API again while the modal is open - this should be prevented */

    getAccessToken(demographyUrl, ubkValue)
      .then((result: any) => {
        if (!result?.errMsg) {
          if (!isAboveEighteenAge(result.demographics.dateOfBirth)) {
            setIsBelowMinAgeLimit(true);
          } else {
            if (!(isOffExchange || isOnExchange) && prepopModalOpen === false) {
              getAccessToken(memberPlanUrl, ubkValue)
                .then((memberResult: any) => {
                  if (!memberResult?.errMsg) {
                    getOnOffExchange(memberResult?.plans);
                    // const res = memberResult?.plans?.[0];
                    const newResponse = getClient(memberResult?.plans);
                    getTobaccoInfoData(
                      `${tobaccoAPIUrl}?clientId=${newResponse?.clientNumber}&groupId=${newResponse?.groupNumber}`,
                    );
                  } else {
                    setPrepopModalOpen(true);
                  }
                })
                .catch(() => {
                  setPrepopModalOpen(true);
                });
            }

            if (!isACA && nonACAModalOpen === false) {
              setNonACAModalOpen(true);
            }
          }
        } else {
          setPrepopModalOpen(true);
        }
      })
      .catch(() => {
        setPrepopModalOpen(true);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isACA,
    nonACAModalOpen,
    prepopModalOpen,
    setTobaccoApiResponse,
    isOffExchange,
    isOnExchange,
    memberPlanUrl,
    // tobaccoUseUrl,
  ]);

  if (isBelowMinAgeLimit) {
    return null;
  }

  if (isACA) {
    return isOffExchange || isOnExchange ? (
      <div>
        <StackLayout
          spacing="$oneAndHalf"
          css={{ paddingBottom: '24px' }}
          horizontalAlignment="stretch"
        >
          {!isBelowMinAgeLimit && (
            <>
              <HeadingText level="1" size="xxl">
                {TobaccoUsageLabel.labels.title}
              </HeadingText>
              <UtilityText>
                {TobaccoUsageLabel.labels.aca_requirement}
              </UtilityText>
              {isOffExchange && !isOnExchange && (
                <UtilityText>
                  {TobaccoUsageLabel.labels.form_requirement}
                </UtilityText>
              )}
              {!isOffExchange && isOnExchange && (
                <UtilityText css={{ fontWeight: '900' }}>
                  {TobaccoUsageLabel.labels.onexchange_changes}
                </UtilityText>
              )}
            </>
          )}
        </StackLayout>
        <StackLayout spacing="$two" horizontalAlignment="stretch">
          {!isBelowMinAgeLimit && (
            <>
              <LoginUser />
              <Dependents />
            </>
          )}
        </StackLayout>
      </div>
    ) : (
      <>
        {!prepopModalOpen && <LoadingIndicator inline />}
        <NotificationModal
          modalOpen={prepopModalOpen}
          onOpenChange={() => {
            if (prepopRetryCount.current < 2) {
              setPrepopModalOpen((previous: boolean) => !previous);
              prepopRetryCount.current += 1;
            } else navigate('/home');
          }}
          type="Error"
          description="Oops! Something went wrong."
        />
      </>
    );
  }
  if (!isACA) {
    return (
      <NotificationModal
        modalOpen={nonACAModalOpen}
        onOpenChange={() => {
          setNonACAModalOpen((previous: boolean) => !previous);
        }}
        type="Error"
        description="Something went wrong, but we'd like make it right. For further assistance, please call the number on the back of your ID card or send us a message via the Support page."
      />
    );
  }
  return null;
}
// initialization of all data happens in LoginUser

// main render
export function TobaccoUseForm(props: any) {
  const { hideButton, showModal, setShowModal, ubkValue } = props;
  const [mainFormModalIsOpen, setMainFormModalIsOpen] = useState<boolean>(
    showModal || false,
  );

  // if a loginUser is a subscriber and is off-exchange all of their dependents are also off-exchange
  const isOffExchange = useTobaccoStore(
    (state) => state.loginUser.isOffExchange,
  );

  const isOnExchange = useTobaccoStore((state) => state.loginUser.isOnExchange);

  const isBelowMinAgeLimit = useTobaccoStore(
    (state) => state.isBelowMinAgeLimit,
  );

  const disclaimer = useMemo(
    () => (
      <UtilityText emphasis="subtle">
        {TobaccoUsageLabel.labels.disclaimer}
      </UtilityText>
    ),
    [],
  );

  return (
    <AccountManagementContainer
      buttonLabel={TobaccoUsageLabel.labels.title}
      modalTitle={TobaccoUsageLabel.labels.title}
      isOpen={mainFormModalIsOpen}
      setIsOpen={setMainFormModalIsOpen}
      hideButton={hideButton}
      showModal={showModal}
      submitButton={
        isOffExchange &&
        !isBelowMinAgeLimit && <SubmitButton ubkValue={ubkValue} />
      }
      backToAcctMgmtControl={() => {
        // TODO allow the user to interrupt the API call and return to account management instead of
        // loading the pre-population data behind the scenes if the user clicks back while the form is still "Loading"
        if (setShowModal !== undefined) setShowModal(false);
        setMainFormModalIsOpen(false);
      }}
      trailingContent={
        !isBelowMinAgeLimit && (isOffExchange || isOnExchange) && disclaimer
      }
    >
      <FormContent
        isOffExchange={isOffExchange}
        isOnExchange={isOnExchange}
        ubkValue={ubkValue}
      />
    </AccountManagementContainer>
  );
}
